/* eslint quotes: "off" */
import $ from "jquery";

export const handleLang = () => {
  $('.nav__toggle.nav__toggle_lang').click(function(e) {
    e.preventDefault();
    if (!$('.nav__toggle.nav__toggle_lang').hasClass( "active")){
      //CLEAN
      $('.nav-dropdown.nav_dropdown_lang').hide(10);
      $('.nav-dropdown.nav_dropdown_burgerMenu').hide(10);
      $('.nav__toggle.nav__toggle_lang').removeClass( "active");
      $('.nav__toggle.nav__toggle_burgerMenu').removeClass( "active");
      $('#nav_dropdown_lang').hide(10);
      $('.black-overlay').hide(10);
      // CLEAN END

      $('.nav__toggle.nav__toggle_lang').addClass( "active");
      $('.nav-dropdown.nav_dropdown_lang').show(200);
      $('.black-overlay').show(200);
    }
    else{
      $('.nav__toggle.nav__toggle_lang').removeClass( "active");
      $('.nav-dropdown.nav_dropdown_lang').hide(200);
      $('.black-overlay').hide(200);
    }
  });
  $('.black-overlay').click(function() {
    $('.nav__toggle.nav__toggle_lang').removeClass('active');
    $('.nav__toggle.nav__toggle_burgerMenu').removeClass('active');
    $('.black-overlay').hide(200);
    $('#nav_dropdown_user, #nav_dropdown_lang, #nav_dropdown_notif, #nav_dropdown_burgerMenu, #get_started_menu').stop().fadeOut(200);
  });
};

export const closeBanner = () => {
  document.getElementById('bonusclose').addEventListener('click', function (e) {
    e.preventDefault();
    this.parentNode.style.display = 'none';
  }, false);
};

export const handleBurgerMenuActiveChoice = () => {
  $('#nav_dropdown_burgerMenu li a').click(function(e) {
    $("#nav_dropdown_burgerMenu li a").removeClass("active");
    $(this).addClass("active");

    $('.nav__toggle.nav__toggle_burgerMenu').removeClass('active');
    $('.nav__toggle.nav__toggle_lang').removeClass('active');
    $('.black-overlay').hide(500);
    $('#nav_dropdown_user, #nav_dropdown_burgerMenu, #nav_dropdown_notif, #nav_dropdown_lang, #get_started_menu').stop().fadeOut(200);
  });
};

export const handleLangMenuActiveChoice = () => {
  $('#nav_dropdown_lang li a').click(function(e) {
    $("#nav_dropdown_lang li a").removeClass("active");
    $(this).addClass("active");

    $('.nav__toggle.nav__toggle_burgerMenu').removeClass('active');
    $('.nav__toggle.nav__toggle_lang').removeClass('active');
    $('.black-overlay').hide(500);
    $('#nav_dropdown_user, #nav_dropdown_burgerMenu, #nav_dropdown_notif, #nav_dropdown_lang, #get_started_menu').stop().fadeOut(200);
  });
};
export const handleBurger = () => {
  $('.nav__toggle.nav__toggle_burgerMenu').click(function(e) {
    e.preventDefault();
    if (!$('.nav__toggle.nav__toggle_burgerMenu').hasClass( "active")){
      //CLEAN
      $('.nav-dropdown.nav_dropdown_lang').hide(10);
      $('.nav-dropdown.nav_dropdown_burgerMenu').hide(10);
      $('.nav__toggle.nav__toggle_lang').removeClass( "active");
      $('.nav__toggle.nav__toggle_burgerMenu').removeClass( "active");
      $('#nav_dropdown_lang').hide(10);
      $('.black-overlay').hide(10);
      // CLEAN END

      $('.nav__toggle.nav__toggle_burgerMenu').addClass( "active");
      $('.nav-dropdown.nav_dropdown_burgerMenu').show(200);
      $('.black-overlay').show(200);
    }
    else{
      $('.nav__toggle.nav__toggle_burgerMenu').removeClass( "active");
      $('.nav-dropdown.nav_dropdown_burgerMenu').hide(200);
      $('.black-overlay').hide(200);
    }
  });
  $('.black-overlay').click(function() {
    $('.nav__toggle.nav__toggle_burgerMenu').removeClass('active');
    $('.nav__toggle.nav__toggle_lang').removeClass('active');
    $('.black-overlay').hide(200);
    $('#nav_dropdown_user, #nav_dropdown_burgerMenu, #nav_dropdown_notif, #nav_dropdown_lang, #get_started_menu').stop().fadeOut(200);
  });
};

export const closeTab = () => {
  $('.nav__toggle').removeClass('active');
  $('.black-overlay').stop().fadeToggle(200);
  $('.black-overlay').css('display','none');
  $('.nav_dropdown_lang, .nav_dropdown_burgerMenu, #nav_dropdown, #get_started_menu').stop().fadeOut(200);
  $('.nav_dropdown_lang .nav_dropdown_burgerMenu').removeClass('active');
};

export const squareLoaderAnimation = () => {
  // square animation
  const height = $(document).height();
  const width = $(document).width();
  const offset = 2 * width + 2 * height;
  $('.square-loader svg rect').css({'stroke-dasharray':offset, 'stroke-dashoffset':offset});
  // start the timer
  $('.square-loader').addClass('start');
};

export const randomSearchAnimation = (vueInstance) => {
  let counter = 0;
  vueInstance.timer = setInterval(() => {
    counter++;
    const random = Math.floor(Math.random()*(16-1+1)+1);
    $('.avatar-item').removeClass('active');
    $('.avatar-item:nth-child('+random+')').addClass('active');
  }, 400);
};

export const opponentFoundVSText = () => {
  const el = $('.opponent-found__vs');
  const w = el.width();
  const h = el.height();
  const $text = $('.opponent-found__vs span');
  $text.css('font-size',w/1.8);
};

export const pieChartAnimation = (selectorElement, percent) => {
  if(!$(selectorElement).length) {
    return;
  }
  const el = selectorElement;
  const donut = true;
  percent = Math.round(percent);
  if (percent > 100) {
    percent = 100;
  } else if (percent < 0) {
    percent = 0;
  }
  const deg = Math.round(360 * (percent / 100));

  if (percent > 50) {
    $(el + ' .pie').css('clip', 'rect(auto, auto, auto, auto)');
    $(el + ' .right-side').css('transform', 'rotate(180deg)');
  } else {
    $(el + ' .pie').css('clip', 'rect(0, 1em, 1em, 0.5em)');
    $(el + ' .right-side').css('transform', 'rotate(0deg)');
  }
  if (donut) {
    $(el + ' .right-side').css('border-width', '16px');
    $(el + ' .left-side').css('border-width', '16px');
    $(el + ' .shadow').css('border-width', '16px');
  } else {
    $(el + ' .right-side').css('border-width', '1.0em');
    $(el + ' .left-side').css('border-width', '1.0em');
    $(el + ' .shadow').css('border-width', '1.0em');
  }
  $(el + ' .left-side').css('transform', 'rotate(' + deg + 'deg)');
};

export const updateProgressBarGamesWon = (percent) => {
  $('#gamesWon').each(function(i, obj) {
    $(obj).width(percent+"%");
  });
};

export const updateProgressBarAnswersPercent = (percent) => {
  $('#correctAnswers').each(function(i, obj) {
    $(obj).width(percent+"%");
  });
};

export const spinTheWheel = (clicks, degree, num) => {
    //add 1 every click
    clicks ++;

    /*multiply the degree by number of clicks
     generate random number between 1 - 360,
     then add to the new degree*/
    const newDegree = degree * clicks;
    const extraDegree = Math.floor(((6 - (num + 1))*(1/6) + (1/6)) * (360 - 1 + 1)) + 1;
    const totalDegree = newDegree + extraDegree;

    /*let's make the spin btn to tilt every
     time the edge of the section hits
     the indicator*/
    $('#wheel .sec').each(function(){
      let t = $(this);
      let c = 0;
      let n = 700;
      const interval = setInterval(function () {
        c++;
        if (c === n) {
          clearInterval(interval);
        }
        let aoY = t.offset().top;
        $("#txt").html(aoY);

        /*23.7 is the minumum offset number that
         each section can get, in a 30 angle degree.
         So, if the offset reaches 23.7, then we know
         that it has a 30 degree angle and therefore,
         exactly aligned with the spin btn*/
        if (aoY < 23.89){
          $('#spin').addClass('spin');
          setTimeout(function () {
            $('#spin').removeClass('spin');
          }, 100);
        }
      }, 10);
      $('#inner-wheel').css({
        'transform' : 'rotate(' + totalDegree + 'deg)'
      });
    });
  return clicks;
};

export const stopSpinningTheWheel = () => {
  const wheel = $('#inner-wheel');
  const e = wheel.css('transform'); // get the current state
  wheel.css('transform', e);
};

// TODO remove if not needed
// export const autoChooseThemeAnimation = (vueInstance) => {
//   let counter = 0;
//   let previousRandomIndex = 1;
//   let currentRandomIndex = 1;
//   vueInstance.timer = setInterval(function() {
//     counter++;
//     // console.log(`In SelectTheme: counter = ${counter}`);
//     if(vueInstance.isFinalRound) {
//       shuffle(vueInstance.availableThemesHTMLElementIndices, new Date());
//       currentRandomIndex = vueInstance.availableThemesHTMLElementIndices[0] === previousRandomIndex
//                           ? vueInstance.availableThemesHTMLElementIndices[1]
//                           : vueInstance.availableThemesHTMLElementIndices[0];
//       previousRandomIndex = currentRandomIndex;
//       console.log(`currentRandomIndex: ${currentRandomIndex}`);
//       $('.cat-item').removeClass('active');
//       $('.cat-item:nth-child(' + currentRandomIndex + ')').addClass('active');
//       // 6 sec has elapsed, select a theme randomly
//       if (counter === 12) {
//         clearInterval(vueInstance.timer);
//         if (vueInstance.isHomePlayer) {
//           shuffle(vueInstance.availableThemes, new Date());
//           vueInstance.storeSelectedTheme(vueInstance.availableThemes[0]);
//         }
//       }
//     }
//   }, 500);
// };



// WEBPACK FOOTER //
// ./src/common/jQuery.js